export const IshActions = {
  // Enrol
  GET_OR_CREATE_CONTACT: "GET_OR_CREATE_CONTACT",

  /**
   * @Deprecated keep only for examples will be removed
   */
  SUBMIT_ADD_CONTACT_FORM: "SUBMIT_ADD_CONTACT_FORM",
  SUBMIT_ADD_PAYER_FORM: "SUBMIT_ADD_PAYER_FORM",

  // Common
  AUTOCOMPLETE: "AUTOCOMPLETE",
  AUTOCOMPLETE_CLEAR: "AUTOCOMPLETE_CLEAR",
};
